import { createFileRoute } from '@tanstack/react-router';

import { ChannelDashboardShell } from '@/features/channel-dashboard/channel';

export const Route = createFileRoute('/_channels/channels')({
  component: ChannelDashboardShell,
});
